module.exports = {
  name: 'Longhorn UI',
  prefix: 'antdAdmin',
  logoSrc: 'favicon.ico',
  version: 'v1.6.2', // eslint-disable-line no-template-curly-in-string
}
